import { render, staticRenderFns } from "./Mensal.vue?vue&type=template&id=409cffc8"
import script from "./Mensal.vue?vue&type=script&lang=js"
export * from "./Mensal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports